import axios from "axios";
import { getCookie } from "./getCookie";
import { getApiUrl } from "./getApiUrl";

export const createMonitoringAPICall = (path: string) => {
  const baseURL = getApiUrl();
  const instance = axios.create({
    baseURL: `${baseURL}monitoring-api/${path}`,
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Add a request interceptor
  instance.interceptors.request.use(
    (config) => {
      // Get the token *before* the request is sent
      const token = getCookie("token");
      if (token) {
        // Ensure headers object exists before assigning to it
        if (!config.headers) {
          config.headers = {};
        }
        // Set the Authorization header dynamically
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config; // Return the modified config
    },
    (error) => {
      // Handle request error
      return Promise.reject(error);
    }
  );

  return instance; // Return the instance with the interceptor attached
};
